<template>
  <footer id="footer" class="c-footer">
    © 2019 memorii
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    image: String
  }
}
</script>
